import React, { FC } from 'react'
import styled from 'styled-components'
import { theme, Row, Space } from 'ui'


const Content = styled.div`
  background-color:${theme.color.white};
  padding: 1rem;
  border-radius: 8px;
`

const StyledText = styled.div`
  flex:1;
  line-height:24px;
`
const StyledMainTitle = styled.div`
  text-decoration: underline;
  font-size: 2rem;
  text-align: center;
`
const StyledDescriptionText = styled.div`
`

const StyledSubTitle = styled.div`
  text-decoration: underline;
  font-size: 1.4rem;
  text-align: center;
`
const StyledRow = styled(Row)`
  margin-left:10px;
  margin-bottom: 0.5rem;
`
const StyledMainText = styled.div`
  margin:5px 0;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`

const Section = ({ number, text }: { number: string, text: any }) => {
  return (
    <StyledRow>
      <div>
        <div>{number}</div>
      </div>
      <Space />
      {text}
    </StyledRow>
  )
}

const B = (props: any) => <b>{props.children}</b>
const Link = (props) => <a {...props} />

interface Props {
  heightMultiply?: number
}

const uri = 'https://mekometerms.z6.web.core.windows.net/'

const Terms: FC<Props> = () => {
  return (
    <Content>
      <StyledMainTitle>
        אפליקציית 'מקומי' - תנאי שימוש
      </StyledMainTitle>
      <StyledSubTitle
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >
        ***הכתוב מטה מתייחס באופן שווה לכל מין ומגדר, ומנוסח בלשון זכר מטעמי נוחות בלבד***
      </StyledSubTitle>
      <StyledSubTitle
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >
        מתחת לגיל 18? הכתוב מטה עשוי להיות מעט מורכב. אנא היוועץ במבוגר אחראי לפני השימוש בפלטפורמה
      </StyledSubTitle>
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >
        1.  כללי
      </StyledMainText>
      <Section
        number={'1.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >
          משתמש יקר! ברוך הבא לאפליקציית 'מקומי' (להלן "<B>האפליקציה</B>"), המנוהלת ומופעלת על-ידי משק-גל, פתרונות תשלום ומידע בקיבוצים ואגש"ח בע"מ (להלן "<B>האגודה</B>")</StyledText>}
      />
      <Section
        number={'1.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >
          מטרת מסמך תנאי שימוש זה הינה להבהיר ולהסדיר את היחסים בינך, לרבות כלל לקוחות האגודה אשר עושים שימוש במגוון שירותיה (להלן ״<B>המשתמש</B>" או "<B>המשתמשים</B>"), לבין האגודה.
        </StyledText>}
      />
      <Section
        number={'1.3'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >
          האפליקציה משמשת את המשתמשים לצרכים שונים, ובין היתר מנהלת את ממשק ההתקשרות ביניהם לבין האגודה, לרבות לצורך סליקה ו/או תשלומים ו/או הפצת הודעות ו/או ניהול מידע בקהילה הקיבוצית וכיו"ב.
    </StyledText>}
      />
      <Section
        number={'1.4'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >שימוש באפליקציה, לרבות בכל תוכן ו/או שירות המופיע בה, מהווה הסכמה לתנאי שימוש אלה, לרבות מדיניות הפרטיות בה ניתן לצפות <Link target="_blank" href="https://mekome.net/privacy"><B>כאן</B></Link>, אשר יעודכנו מעת לעת (להלן ביחד "<B>המסמכים הדיגיטליים</B>"). האגודה שומרת לעצמה את הזכות, בהתאם לשיקול דעתה המלא והבלעדי, לשנות, למחוק או להוסיף על תנאי שימוש אלה בכל עת ומבלי להיזקק למתן הודעה מוקדמת מעבר לפרסום ההוראות בתנאי השימוש עצמם. אשר על כן, טרם ביצוע פעולה כלשהי באפליקציה, הנך מתבקש לקרוא בעיון את המסמכים הדיגיטליים, שכן המשך שימוש באפליקציה גם במקרה בו יעשו שינויים כאמור, יעיד על הסכמתך לתנאי השימוש. ככל ואינך מסכים לשינויים כאמור, עליך להימנע מהמשך שימוש באפליקציה.
    </StyledText>}
      />
      <Section
        number={'1.5'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > נוסח תנאי השימוש המחייב והקובע בכל מועד הוא זה המפורסם באפליקציה. תנאי השימוש הינם מצטברים ואינם חלופיים, והם יפורשו כמתקיימים זה לצד זה ולא מצמצמים זה את זה או גורעים האחד מן השני. מובהר כי הנך רשאי לבחור לעשות שימוש רק בחלק מהמידע ו/או השירותים המוצעים באפליקציה ולא בכולם. כמו כן, ייתכן כי חלק מהשירותים המוצעים באפליקציה אינם פעילים עדיין, והם יעמדו לרשותך עם הפעלתם.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >
        2.  שימושים אסורים באפליקציה
      </StyledMainText>
      <Section
        number={'2.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > ללא מתן הרשאה מפורשת מהאגודה, מראש ובכתב, המשתמש ו/או צד שלישי כלשהו אינם רשאים לבצע את הפעולות ו/או המעשים הבאים באפליקציה ובתוכנה:
    </StyledText>}
      />
      <Section
        number={'1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > שימוש מסחרי באפליקציה ו/או בתוכן המופיע בה, כולם או חלקם.</StyledText>} />
      <Section
        number={'2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >   להעתיק, לשחזר, לשנות, לעבד, לתרגם, לבצע הנדסה לאחור (לרבות כל ניסיון להפיק את קוד המקור של האפליקציה ו/או התוכן המופיע בה), לפרסם, להפיץ, לשדר, להציג, לבצע, לשכפל, למכור, להעניק רישיונות משנה וכיו"ב באפליקציה, כולה או חלקה.</StyledText>}
      />
      <Section
        number={'3'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > לעקוף, להשבית ו/או להפריע בדרך אחרת לאמצעי האבטחה באפליקציה ו/או לעבודתה התקינה, לרבות הפעלת כל יישום מחשב, תוכנות מסוגCrawlers, Robots וכדומה ו/או לפגוע ו/או לשבש את מערך הגנות הסיסמאות המסדירות את הגישה לאפליקציה.
    </StyledText>}
      />
      <Section
        number={'4'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > לאפשר לצד שלישי אשר אינו משתמש מורשה לעשות שימוש באפליקציה ו/או בתוכן המופיע בה בכלל ולעשות בה שימוש לעיצוב ו/או פיתוח שירות או מוצר מתחרים בפרט.
    </StyledText>}
      />
      <Section
        number={'5'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > לשבש או להפר כל זכות של משתמש אחר באפליקציה, לרבות הזכות לפרטיות ו/או איסוף מידע אישי על המשתמשים באפליקציה ללא הסכמתם המפורשת מראש ובכתב, לרבות באמצעים אוטומטיים.
    </StyledText>}
      />
      <Section
        number={'6'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > להסיר, להשחית, להסתיר ו/או לשנות את האפליקציה ו/או כל תוכן המופיע בה, לרבות זכויות יוצרים, סימנים מסחריים ו/או זכויות קנייניות אחרות, לרבות עשיית שימוש בשמה, סמלה המסחרי או סימני המסחר של האגודה, מבלי לקבל לכך את הסכמתה המפורשת, מראש ובכתב.
    </StyledText>}
      />
      <Section
        number={'7'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > לפגוע בכבודו או בפרטיותו של משתמש אחר ו/או לשנות תוכן שפורסם על ידי משתמש אחר ו/או לפרסם תוכן בשם משתמש אחר ו/או להשתמש באפליקציה ו/או בתוכן המופיע בה כדי לפגוע בשמו הטוב של כל אדם ו/או לפרסם דברי הסתה, הונאה, תרמית, לשון הרע ו/או כל מידע אחר שהינו שקרי, בלתי אמין או שיש בו כדי לפגוע במזיד.
    </StyledText>}
      />
      <Section
        number={'8'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >שימוש באפליקציה ו/או בתוכן המופיע בה לשם יצירת מאגר מידע ו/או לקט.
    </StyledText>}
      />
      <Section
        number={'2.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > האגודה רשאית, בהתאם לשיקול דעתה המלא והבלעדי, לא לאשר, להשעות או לחסום, מבלי להיזקק למתן הודעה מראש, את הגישה של כל משתמש ו/או צד שלישי לאפליקציה, כולה או חלקה, ו/או לכל תוכן או שירות המוצע במסגרתה, וזאת במקרים בהם סבורה האגודה כי בוצעה הפרה של תנאי שימוש אלה ו/או כי קיים חשש כי תיגרם הפרעה מכל סוג שהוא לפעילותה התקינה של האפליקציה ו/או אספקת השירותים המוצעים בה, או חשש להפרת הוראות הדין ו/או זכויות של צדדים שלישיים, ו/או מכל סיבה אחרת בהתאם לשיקול דעתה המלא והבלעדי של האגודה, גם ללא כל סיבה או הצדקה, והמשתמש ו/או צד שלישי כלשהו מוותרים על כל טענה ו/או דרישה ו/או תביעה כנגד האגודה ו/או כל מי מטעמה בעניין זה.
    </StyledText>}
      />
      <Section
        number={'2.3'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > אי עמידה במגבלות אלה עלולה להוביל כאמור למניעת גישת המשתמש לאפליקציה ואף לחשוף אותו לאחריות אזרחית ו/או פלילית, בהתאם להוראות כל דין.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >
        3.  הרשמה ושימוש במידע
    </StyledMainText>
      <Section
        number={'3.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > הרישום לאפליקציה ו/או עשיית שימוש בה, טעונים מסירת מידע אישי. השימוש במידע אשר מסר המשתמש לאגודה במסגרת האפליקציה ו/או במידע שהצטבר אודותיו בעת השימוש בה, לרבות שם מלא, מספר תעודת זהות, כתובת מגורים, כתובת דואר אלקטרוני, מספר טלפון, קשרים משפחתיים, מידע פיננסי, פרטי פעילות משתמשים וכדומה, יתבצע בהתאם להוראות הדין ומדיניות הפרטיות של האפליקציה, המהווה חלק בלתי נפרד מתנאי השימוש. למידע נוסף בעניין זה ובכלל, תוכל להיכנס
          <Link target="_blank" href={uri}> מדיניות הפרטיות</Link>  של האפליקציה.

    </StyledText>}
      />
      <Section
        number={'3.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > מובהר כי כל נושא התשלומים הנעשה במסגרת האפליקציה, לרבות סליקת כרטיסי האשראי ולרבות סליקה באמצעות מערכת חברת מס"ב בע"מ, בהתאם למתן הרשאה לחיוב חשבון המשתמש, נעשים באופן מוצפן ומאובטח באמצעות חברת סליקת אשראי חיצונית, העושה שימוש בשיטות ההצפנה המקובלות והחדישות בתחום, ועל-ידי מנגנוני הצפנה אשר הינם בהתאם לתקנים בינלאומיים.
    </StyledText>}
      />
      <Section
        number={'3.3'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > מובהר כי כל נושא התשלומים הנעשה במסגרת האפליקציה, לרבות סליקת כרטיסי האשראי ולרבות סליקה באמצעות מערכת חברת מס"ב בע"מ, בהתאם למתן הרשאה לחיוב חשבון המשתמש, נעשים באופן מוצפן ומאובטח באמצעות חברת סליקת אשראי חיצונית, העושה שימוש בשיטות ההצפנה המקובלות והחדישות בתחום, ועל-ידי מנגנוני הצפנה אשר הינם בהתאם לתקנים בינלאומיים.
    </StyledText>}
      />

      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >4. אבטחת החשבון</StyledMainText>
      <Section
        number={'4.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > השימוש באפליקציה ו/או בשירותים המוצעים בה, לרבות אמצעי התשלום, הינו בכפוף לכך שהמכשיר בו נעשה שימוש נמצא בבעלותך / ברשותך הבלעדית והוא מוגן בקוד נעילה הידוע רק לך, וזאת על מנת למנוע את חשיפת המידע, כגון נתוני האשראי שלך וכיו"ב לצדדים שלישיים. כמו כן, על המכשיר בו נעשה שימוש להיות בעל יכולת תמיכה בקבלת ושליחה של מסרונים (הודעות SMS) ובהפעלה של פרוטוקול גלישה אינטרנטית באמצעות רשת סלולר.
    </StyledText>}
      />
      <Section
        number={'4.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > האחריות לשמירה על החשבון שלך ועל הגישה אליו, חלה עליך בלבד. האגודה לא תישא בכל אחריות להתנהלות עצמאית מצדך באפליקציה ו/או כל פעולה המבוצעת על-ידך או צד שלישי ו/או ביחס לשימוש ו/או תשלום שיתבצע כאמור.
    </StyledText>}
      />
      <Section
        number={'4.3'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > על מנת לבצע פעולות מסוימות באפליקציה, לרבות העברת תשלומים, תידרש לבחור אמצעי הזדהות בהתאם להנחיות האגודה, כפי שיינתנו מעת לעת. האגודה תהא רשאית לדרוש ממך להחליף את אמצעי ההזדהות מעת לעת ו/או להוסיף להאמצעי זיהוי נוספים כתנאי לביצוע פעולות מסוימות באפליקציה. כמו כן, יתכן כי לצורך ביצוע אחת או יותר מהפעולות באפליקציה, תישלח אליך סיסמא חד פעמית למכשיר בו נעשה שימוש לצורכי אימות זיהוי.
    </StyledText>}
      />
      <Section
        number={'4.4'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > הנך מתחייב לעשות כל שביכולתך על מנת לשמור על סודיות אמצעי ההזדהות, ולא לגלותם ו/או למסור אותם לכל צד שלישי שאינו מורשה לפעול מטעמך באפליקציה.
    </StyledText>}
      />
      <Section
        number={'4.5'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > בכל מקרה בו יתעורר אצלך חשד לשימוש לרעה באפליקציה ו/או לאבדן של אחד מאמצעי הזיהוי אשר מאפשרים להזדהות מולה, הנך נדרש להודיע על כך מידית לאגודה בדרכי יצירת הקשר מטה.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >5. שליחה וקבלת תשלומים </StyledMainText>
      <Section
        number={'5.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > מסגרת האפליקציה ובמהלך השימוש בה (בהתאם לתנאי שימוש אלה והוראות הדין), תתאפשר, בין היתר, גם העברה (שליחה וקבלה) של תשלומים. במקרה כזה, כל עסקה שתבצע על-ידך תחויב אוטומטית באמצעות כרטיס החיוב ו/או אמצעי החיוב/הרשאה לחיוב חשבון הבנק שלך, כאשר מובהר כי האגודה אינה צד לעסקאות בינך ובין כל גורם אחר, ואין ולא תהא לה כל אחריות בקשר עם האמור.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >6. בעלות וזכויות קניין רוחני</StyledMainText>
      <Section
        number={'6.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > האפליקציה והתוכן המופיע בה, לרבות עיצובים, איורים, תמונות, מפות, קטעי אודיו / וידאו, טקסט, גרפיקה, תוכנה, יישום, קוד מקור וכל חומר אחר וכיו"ב (להלן "
          התוכן" או "התכנים") מוגנים על-ידי דיני זכויות יוצרים ושייכים לאגודה ו/או מי מטעמה ו/או לצד שלישי אשר העניק לאגודה זכות שימוש מלאה בהם. משכך, חל איסור מוחלט על המשתמש ו/או צד שלישי כלשהו להכניס שינויים, לבצע הליך הנדסה לאחור, להעתיק, לפרסם, להפיץ, לשדר, להציג בפומבי, לבצע, לשכפל, להנפיק רישיון, ליצור עבודות נגזרות, למכור או למסור לצד שלישי וכיו"ב כל חלק מן התוכן מבלי לקבל את הסכמתה המפורשת של האגודה, מראש ובכתב.
    </StyledText>}
      />
      <Section
        number={'6.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > כל זכויות הקניין הרוחני בקשר עם האפליקציה מכל מין וסוג שהוא (וזאת בין אם המדובר בזכויות רשומות ובין אם המדובר בזכויות שטרם נרשמו), ובכלל זאת שם המתחם ("
          Domain"), הפטנטים, סימני המסחר, שמות המסחר, המדגמים, זכויות יוצרים, סודות מסחריים, השיטות, אופן הצגתה ועיצובה של האפליקציה וכן כל עניין ו/או פרט הקשורים באפליקציה, הינם רכושה המלא והבלעדי של האגודה ו/או מי מטעמה ו/או של צד שלישי, אשר הרשה לאגודה לעשות בהן שימוש. משכך, אין להעתיק, להפיץ, לשכפל, למכור, לתרגם ו/או לבצע פעולה אחרת כלשהי בכל סוגי הטקסטים ו/או קודים ו/או תמונות ו/או סמני מסחר ו/או תצלומים ו/או סרטונים ו/או כל תוכן אחר המופיע באפליקציה, אלא אם התקבל לכך אישור מפורש מהאגודה, מראש ובכתב.
        </StyledText>}
      />
      <Section
        number={'6.3'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > סימני המסחר ומודעות הפרסומת של מפרסמים באפליקציה (ככל שקיימים), הינם קניינם של מפרסמים אלה בלבד. מובהר כי גם בהם אין לעשות כל שימוש מבלי לקבל את הסכמתם המפורשת של המפרסמים, מראש ובכתב.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >7. תוכן האפליקציה ופרסומות </StyledMainText>
      <Section
        number={'7.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > האפליקציה והתכנים המופיעים בה מוצעים לציבור ולמשתמשים כמות שהם (As Is). האגודה עושה מאמצים על מנת שהתוכן המופיע באפליקציה יהא נכון, מדויק ועדכני. יחד עם זאת, האגודה אינה מתחייבת לכך, ויתכן כי התוכן אינו שלם ו/או שנפלו בו טעויות טכניות או אחרות, ולכן האגודה לא תישא באחריות כלשהי לעדכניות, דיוק ושלמות המידע המצוי באפליקציה.
    </StyledText>}
      />
      <Section
        number={'7.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > האגודה שומרת לעצמה את הזכות, לפי שיקול דעתה המלא והבלעדי, לשנות בכל עת את האפליקציה, המידע והשירות המוענק במסגרתה, ובכלל זה על-ידי הוספה, גריעה, הפסקה או הגבלה, שינוי מבנה האפליקציה, היקפם וזמינותם של המידע והשירותים המוצעים בה וכל היבט אחר הכרוך בה, בשירות ובתפעול, מבלי להיזקק למתן הודעה מוקדמת. מובהר, כי למשתמש ו/או לצד שלישי כלשהו לא תהא כל טענה ו/או דרישה ו/או תביעה כלפי האגודה בגין האמור.
    </StyledText>}
      />
      <Section
        number={'7.3'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > באפליקציה עשויים להיות מוצגים, תוכן, פרסומים, פרסומות, כתבות, מידע, שירותים, מוצרים ו/או כל תוכן אחר של צדדים שלישיים ו/או מטעמם, בין באמצעות הפניית המשתמש לאתרים של צדדים שלישיים ו/או באמצעות הצגתם של אלה באפליקציה (להלן "תוכן של צד שלישי"). מבלי לגרוע מהאמור, השימוש של המשתמש בתוכן של צד שלישי הינו בכפוף לתקנון ו/או תנאי השימוש ו/או מדיניות הפרטיות של אותם צדדים שלישיים, ככל שאלה קיימים. מובהר, כי כל חוות דעת, הבעת עמדה, עצה, הצהרה, הצעה, אינפורמציה, שירות ו/או כל תוכן אחר בתוכן של צד שלישי, הינם של אותו צד שלישי והאגודה אינה מעורבת ביצירתם, עריכתם ו/או הפעלתם.

    </StyledText>}
      />
      <Section
        number={'7.4'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > נוסף על האמור, באפליקציה עשויים להיכלל גם קישורים ('לינקים') לאתרי אינטרנט אחרים, אשר אינם מופעלים על-ידי האגודה. הקישורים נועדו אך ורק לנוחותם ולידיעתם של המשתמשים. קישורים אלה אינם בשליטתה של האגודה והיא אינה מפקחת על תוכן האתרים המקושרים. ככל שהאפליקציה מכילה קישורים אלה, אין בכך כדי להעיד על הסכמה ו/או אחריות של האגודה לתכנים המופיעים באתרים המקושרים ו/או מהווה ערובה לאמינותם, עדכניותם, תקינותם או חוקיותם ו/או למדיניות הפרטיות ותנאי השימוש הננקטים על-ידי בעליהם. האגודה אינה אחראית לכל תוצאה אשר תיגרם כתוצאה מהשימוש באתרים המקושרים ו/או מהסתמכות עליהם וממליצה לקרוא בעיון את תנאי השימוש ומדיניות הפרטיות של אתרים אלה, ככל שקיימים, ו/או לפנות לבעלי האתרים המקושרים בכל מקרה של טענה או בקשה בעניין. עוד מובהר, כי האגודה רשאית, בהתאם לשיקול דעתה המלא והבלעדי, להסיר כל קישור מהאפליקציה ו/או להוסיף קישורים נוספים וכי האגודה אינה מתחייבת כי הקישורים לאתרי האינטרנט האמורים יהיו פעילים ויובילו לאתר אינטרנט פעיל.
    </StyledText>}
      />
      <Section
        number={'7.5'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >כל שימוש בתוכן האפליקציה, לרבות בתוכן המסופק על-ידי האגודה ו/או בתוכן של צד שלישי, לרבות כל כניסה של המשתמש לאתרים של צדדים שלישיים על-ידי הפניה באפליקציה ו/או בפרסומות המופיעות בה, יתבצע על אחריותו הבלעדית של המשתמש, ולא תהא לו כל טענה ו/או דרישה ו/או תביעה כנגד האגודה ו/או מי מטעמה בהקשר זה, לרבות בגין כל נזק ישיר או עקיף, הנובע משימוש ו/או כניסה ו/או הסתמכות על תוכן המופיע באפליקציה ו/או של צד שלישי ו/או בשל פגיעה בפרטיות בעקבות שימוש כאמור. האגודה מציעה למשתמש לבצע בעצמו את כל הערכותיו ובדיקותיו לגבי המידע ו/או השירות אותו הוא מעוניין לקבל, ובכל מקרה המשתמש מוותר ויהא מנוע מלהעלות כל טענה ו/או דרישה ו/או תביעה בעניין זה כלפי האגודה ו/או מי מטעמה.
    </StyledText>}
      />
      <Section
        number={'7.6'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >תכונות, דגמים, עיצוב, צבעים או חזות של השירותים המתוארים ו/או מוצגים באפליקציה, לרבות כל תמונה ו/או הצגה של מוצרים הכלולים באפליקציה, הינם לצורכי המחשה בלבד, אלא אם נאמר מפורשות אחרת. ככל שהמשתמש זיהה ו/או חשד כי קיים פער בין נראות השירות ו/או המוצר המבוקש בפועל לבין פרטי המידע המופיעים באפליקציה בצמוד לכך, יוכל המשתמש לפנות לאגודה אשר תפעל לתקן האת האמור בהתאם לצורך.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >8.  אחריות</StyledMainText>
      <Section
        number={'8.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >האגודה עושה כל שביכולתה על מנת לספק למשתמש חווית שימוש איכותית ובטוחה באפליקציה. יחד עם זאת, האפליקציה אינה חסינה מתקלות ו/או בעיות ועשויה שלא להיות למשתמש גישה לאפליקציה מעת לעת.
    </StyledText>}
      />
      <Section
        number={'8.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > ידוע למשתמש, כי האפליקציה, לרבות כל תוכן ו/או שירות המופיע בה, ניתנים על-ידי האגודה במצבם כפי שהם ובכפוף לזמינותם (As Is ו- As Available). האגודה לא תישא בכל אחריות, מפורשת או משתמעת, בקשר עם האפליקציה לרבות כל תוכן ו/או שירות המופיע בה, וכן בקשר עם התאמתם למטרה ספציפית ו/או לדרישות המשתמש.
    </StyledText>}
      />
      <Section
        number={'8.3'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >המשתמש מצהיר ומתחייב בזה, כי הוא אחראי באופן בלעדי ומלא לכל שימוש שהוא עושה באפליקציה, לרבות בכל תוכן ו/או שירות בו, וכי ידוע לו שהאגודה אינה אחראית, בין במישרין בין בעקיפין, לכל שימוש כאמור.
    </StyledText>}
      />
      <Section
        number={'8.4'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >{`האגודה, בעלי מניותיה, מנהליה וחברות בנות ו/או חברות אם ו/או חברות קשורות לאגודה ו/או כל מי מטעמה, לא יישאו בכל אחריות שהיא, לנזק ו/או אובדן, ישיר או עקיף, לרבות נזק נלווה, תוצאתי, אקראי או פיצויים עונשיים (ובכלל זה, ומבלי לגרוע מכלליות האמור, פיצויים בגין הפסד עבודה ועסקים, הפסד רווחים, הפסקות והפרעות עבודה, הפסד ו/או איבוד מידע עסקי, פגיעה במוניטין, וכל הפסד ו/או נזק כספי אחר), הנובעים ו/או הקשורים, באפליקציה, או בכל תוכן ו/או שירות המופיע בה, או בכל שימוש בהם, ולרבות אך מבלי לגרוע: 1) בשימוש ו/או אי יכולת שימוש באפליקציה, לרבות כל תוכן ו/או שירות המופיע בה, מכל סיבה שהיא; 2) הודעות ו/או קבצים שנתקבלו אצל המשתמש במהלך ו/או עקב השימוש באפליקציה, לרבות כל תוכן ו/או שירות המופיע בה; 3) שימוש או הסתמכות על מידע ותכנים המתפרסמים באפליקציה, בין אם על-ידי האגודה ובין אם על-ידי צדדים שלישיים; 4) כל מעשה ו/או מחדל המתבצע באפליקציה לרבות בתוכן ו/או שירות המופיע בה לרבות לאחר מסירתם לצדדים שלישיים; 5) הפרעות, זמינות ותקינות של האפליקציה, לרבות כל תוכן ו/או שירות המופיע בה, מכל סיבה שהיא, ולרבות, הנובעים משיבושים או מכשלים ברשת האינטרנט או ברשת הטלפוניה; 6) נזק או אובדן אשר נגרם כתוצאה משגגה, טעות, אי דיוק וכיו"ב בתוכן האפליקציה.`}
        </StyledText>}
      />
      <Section
        number={'8.5'}
        text={
          <StyledText
            align={'left'}
            size={17}
            color={theme.color.blackTwo}
          > מבלי לגרוע מהאמור לעיל, ידוע למשתמש כי לשם אספקת השירותים נעזרת האגודה בצדדים שלישיים כגון ענא-גל ניהול 2009 בע״מ ו/או מרכז הסליקה הבנקאי / חברת סליקת אשראי, ומידע (לרבות מידע אישי) עשוי לעבור אל ו/או להתקבל חזרה מגופים אלה בחזרה למשתמש או לאגודה, וכי האגודה תפעל גם בהתאם להנחיות שיתקבלו מגופים אלה. מובהר כי לאגודה אין ולא תהא כל אחריות לכל פעולה של גופים אלה. להסרת ספק, ידוע למשתמש כי ייתכן ותהיינה טעויות ו/או תקלות ו/או חוסרים בתהליך העברת המידע למשתמש ו/או ממנו, בין שמקורן אצלו, בין שמקורן בגופים כאמור, ובין שמקורן באפליקציה ו/או באגודה מכל סיבה שהיא. בהקשר זה, המשתמש מוותר בזאת על כל טענה ו/או דרישה ו/או תביעה מכל סוג שהם כלפי האגודה ו/או מי מטעמה ופוטר אותה מכל אחריות לכל נזק ו/או הפסד שהוא (כספי או אחר) אשר יכול שייגרם למשתמש כתוצאה ו/או בקשר עם האמור, וזאת למעט במקרה בו יוכח כי הנזק נגרם בשל פעולה ישירה בזדון של האגודה.
    </StyledText>}
      />
      <Section
        number={'8.6'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >המשתמש מאשר כי בכל מקרה של סתירה בין נתונים המצויים אצל האגודה ו/או אצל חברות סליקת האשראי לבין אלה המצויים אצלו, יקבעו הנתונים המצויים אצל הגופים המפורטים לעיל, לפי העניין.
    </StyledText>}
      />
      <Section
        number={'8.7'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > על אף האמור בהוראות תנאי שימוש אלה ו/או כל דין, המשתמש מאשר ומסכים כי אחריותה המצטברת והכוללת של האגודה לכל נזק, אובדן ו/או הפסד אשר ייגרמו למשתמש ו/או לצדדים שלישיים כתוצאה ו/או בקשר עם השימוש באפליקציה ו/או בתוכן ו/או השירות המופיעים בה, תהא מוגבלת לנזקים ישירים בלבד, אשר לא יעלו על תקרת התמורה השנתית אשר שולמה על-ידי המשתמש במהלך שנים עשר (12) החודשים הקודמים, ואיננה כוללת נזקים עקיפים, תוצאתיים ו/או אובדן מידע, אובדן נתונים, אובדן הכנסות וכיו"ב.
    </StyledText>}
      />
      <Section
        number={'8.8'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >מובהר, כי שיבוש בקליטת פרטי המשתמש במחשבי האגודה מכל סיבה שהיא, לרבות תקלה הקשורה לאגודה, לא יהווה עילה לכל טענה ו/או דרישה ו/או תביעה מצד המשתמש כלפי האגודה.
    </StyledText>}
      />
      <Section
        number={'8.9'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >המשתמש מתחייב בזאת לציית להוראות כל דין העשויות לחול על שימושו באפליקציה ו/או בתוכן ו/או השירותים המופיעים בה, לרבות תנאי שימוש אלה.
    </StyledText>}
      />
      <Section
        number={'8.10'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >המשמש מתחייב, כי יפצה וישפה את האגודה ו/או כל מי מטעמה, מיד עם דרישתה הראשונה, בגין כל נזק, הפסד, אובדן רווח, תשלום ו/או הוצאה, פגיעה במוניטין, פגיעה כלכלית ו/או מסחרית, לרבות מתוקף כל דרישה, תביעה, פסק דין, פשרה, הוצאה לפועל, ולרבות הוצאות משפט, ועלויות הייעוץ המשפטי, הנובעים, במישרין ו/או בעקיפין, מהפרת תנאי השימוש ו/או כל מעשה ו/או מחדל של המשתמש אשר בעקבותיו תחויב האגודה ו/או מי מטעמה בחיוב כלשהו.
    </StyledText>}
      />
      <Section
        number={'8.11'}
        text={
          <StyledText
            align={'left'}
            size={17}
            color={theme.color.blackTwo}
          >המשתמש מודע לכך שהאגודה רשאית לשנות ו/או להפסיק ו/או לבטל בכל עת, בהתאם לשיקול דעתה המלא והבלעדי, את פעילות האפליקציה וזאת ללא כל צורך במתן הודעה מוקדמת על כך.
    </StyledText>}
      />
      <Section
        number={'8.12'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >בכל סתירה ו/או אי התאמה מכל מין וסוג שהוא בין כל תוכן באפליקציה לבין תנאי שימוש אלה, לרבות מדיניות הפרטיות, יגברו הוראות תנאי השימוש ו/או מדיניות הפרטיות , לפי העניין.
    </StyledText>}
      />
      <Section
        number={'8.13'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > אין בהגבלת האחריות בסעיף זה כדי לגרוע מהגבלת אחריות אחרת בתנאי השימוש ומדיניות הפרטיות.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >9. פעילות האפליקציה</StyledMainText>
      <Section
        number={'9.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >האפליקציה מתוכננת להיות בפעילות 24 שעות ביממה, למעט מקרים בהם תהא מושבתת לצורך תחזוקתה ו/או מכל סיבה אחרת.
    </StyledText>}
      />
      <Section
        number={'9.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >מובהר בזאת, כי ייתכן שיחולו שינויים במועדים המצוינים בתנאי שימוש אלה, לרבות שעות פעילות האפליקציה וכדומה, והכל בהתאם לשיקול דעתה המלא והבלעדי של האגודה.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      > 10. התיישנות</StyledMainText>
      <Section
        number={'10.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        > מבלי לגרוע מהאמור בתנאי השימוש, המשתמש מודע, מסכים ומאשר בזאת, כי תקופת ההתיישנות לגבי כל טענה ו/או דרישה ו/או תביעה כנגד האגודה, תוגבל לתקופה של שישה (6) חודשים, והצדדים רואים בכך כהסכם לתקופת ההתיישנות כמשמעו בסעיף 19 לחוק ההתיישנות, התשי"ח-1958.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >11.סמכות שיפוט וברירת דין</StyledMainText>
      <Section
        number={'11.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >על כל שימוש באפליקציה ו/או על כל טענה ו/או דרישה ו/או תביעה הנובעים משימוש זה ו/או בכל הקשור או הנובע מקבלת שירותי האגודה ו/או בכל דבר ועניין אחר הקשורים באופן ישיר או עקיף לאפליקציה יחולו אך ורק דיני מדינת ישראל. סמכות השיפוט הבלעדית ביחס לאמור תהא נתונה לבית המשפט המוסמך בעיר תל אביב-יפו, והדין המהותי והפרוצדוראלי אשר יחול יהיה הדין הישראלי, אשר יגבר על כל כללי ברירת דין המפנים לתחולת דין זר.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >12. שונות </StyledMainText>
      <Section
        number={'12.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >תנאי שימוש אלה מהווים את ההסכם המלא בינך לבין האגודה בכל הנוגע לאופן השימוש באפליקציה ומחליפים כל הבנה ו/או הסכמה אחרת, בעל-פה או בכתב, הנוגעות לשימוש באפליקציה ו/או בתוכן ו/או בשירותים המופיעים בה.
    </StyledText>}
      />
      <Section
        number={'12.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >אם תנאי מתנאי השימוש ימצא בלתי חוקי, בטל או בלתי אכיף מכל סיבה, תנאי זה ימחק מתנאי השימוש ומחיקתו לא תשפיע על חוקיות ותקפות תנאי השימוש הנותרים. במקרה שכזה, יראו בקיומו של תנאי דומה אחר אכיף במקום התנאי שנמחק או הוסר.
    </StyledText>}
      />
      <Section
        number={'12.3'}
        text={
          <StyledText
            align={'left'}
            size={17}
            color={theme.color.blackTwo}
          >כל שיהוי, ויתור, ארכה, איחור או הימנעות מצד האגודה למימוש זכויותיה ו/או בדרישת קיום תנאי מתנאי שימוש אלה ו/או הסכמתה לסטות מתנאי השימוש לא יהוו תקדים, לא יחשבו לוויתור ו/או הסכמה מצד האגודה ואין להסיק מהן גזירה שווה למקרה אחר.
    </StyledText>}
      />
      <Section
        number={'12.4'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >תנאי השימוש המפורטים לעיל אינם יוצרים ולא יפורשו כיוצרים כל שותפות, מיזם משותף, יחסי עובד מעביד, סוכן או שלוח בין המשתמש לבין האגודה.
    </StyledText>}
      />
      <StyledMainText
        align={'left'}
        size={17}
        color={theme.color.blackTwo}
        weight={700}
      >13. יצירת קשר</StyledMainText>
      <Section
        number={'13.1'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >בכל עניין, שאלה ו/או בקשה, אנא פנו אל התמיכה הטכנית דרך האפליקציה, או במייל: <Link href={'mailto:support@mekome-net.com'}>support@mekome-net.com</Link>. בכל תכתובת לאגודה יש לכלול את פרטיך המלאים לרבות, כתובת ואימייל ליצירת קשר. האגודה תשתדל להגיב לכל בקשה סבירה בזמן סביר.
    </StyledText>}
      />
      <Section
        number={'13.2'}
        text={<StyledText
          align={'left'}
          size={17}
          color={theme.color.blackTwo}
        >כל הודעה אשר תישלח על-ידי האגודה למשתמש וזאת על פי הכתובת כפי שמילא המשתמש בעת הזנת פרטיו במקום הנדרש תיחשב כאילו הגיעה למענה לאחר 48 שעות.
    </StyledText>}
      />
    </Content>
  )
}

export default Terms
